module.exports = __webpack_public_path__ + "static/media/tone-bg.a76f482b.svg";